export default [
  { field: "Nome", required: false, show: true, key: "name", tab: "general" },
  {
    field: "E-mail",
    required: false,
    show: true,
    key: "email",
    tab: "general"
  },
  {
    field: "Identificação",
    required: false,
    show: true,
    key: "identification",
    tab: "general"
  },
  {
    field: "Telefone",
    required: false,
    show: true,
    key: "phone",
    tab: "general"
  },
  {
    field: "Data de Nascimento",
    required: false,
    show: true,
    key: "birth_date",
    tab: "general"
  },
  {
    field: "Observação",
    required: false,
    show: true,
    key: "notes",
    tab: "general"
  },
  { field: "CEP", required: false, show: true, key: "zipcode", tab: "address" },
  {
    field: "Estado",
    required: false,
    show: true,
    key: "state",
    tab: "address"
  },
  { field: "Cidade", required: false, show: true, key: "city", tab: "address" },
  {
    field: "Bairro",
    required: false,
    show: true,
    key: "neighborhood",
    tab: "address"
  },
  {
    field: "Logradouro",
    required: false,
    show: true,
    key: "street",
    tab: "address"
  },
  {
    field: "Número",
    required: false,
    show: true,
    key: "number",
    tab: "address"
  },
  {
    field: "Complemento",
    required: false,
    show: true,
    key: "complement",
    tab: "address"
  }
];



// WEBPACK FOOTER //
// ./src/core/enum/customer-fields.enum.js